<template>
  <div class="section-container section-bg full-bg" :class="{ dark: skinType }">
    <div
      class="section-title d-flex align-items-center justify-content-between"
    >
      <div class="d-flex align-items-center">
        <div class="title-decoration"></div>
        <div class="title" :class="{ 'text-white': skinType }">{{ title }}</div>
      </div>
      <slot name="header" class="section-header-right" style="margin-left: auto"></slot>
    </div>
    <div class="divider" :class="{ dark: skinType }"></div>
    <slot class="section-body d-flex"></slot>
  </div>
</template>
<script>
export default {
  name: 'section-container',
  props: {
    title: {
      type: String,
      default: '标题',
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
};
</script>
<style scoped>
.section-bg {
  border-radius: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}
.title-decoration {
  width: 4px;
  height: 1.5rem;
  background-color: #2e9bf3;
}
.section-body {
  flex-shrink: 1;
  flex-grow: 1;
}
.section-title {
  text-align: left;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  height:2rem;
  color: #333333;
}
.divider {
  height: 1px;
  background-color: #e6e6e6;
}
.divider.dark {
  background-color: #3344aa;
}
.title-center {
  text-align: center;
}
.title {
  padding-left: 10px;
}
.section-container.dark {
  background-color: #223388;
}
</style>
